<template>
  <div class='appointment-detail-wrapper'>
    <div v-if="dataLoaded" class="animated fadeIn step-container">
      <div class="row">
        <div class="col-md-8 offset-md-2 step-body">
          <div class="card-block">
            <div class="row">
              <div class="col-md-6 title-section">
                <h4 class="title-text">{{this.$t('message.appointment.title_edit')}}</h4>
              </div>

              <div class="col-md-6">
                <bs-dropdown class="confirm-btn-lg" :text="appointment.status" :type="dropdownStatus" :disabled="isCancelAppointment">
                  <li class="status-change status-change-btn" v-if="appointment.status !== 'checkin'"><a class="text-success" @click="changeStatus('scheduled')">{{this.$t('message.appointment.status_scheduled')}}</a></li>
                  <li class="status-change status-change-btn" v-if="appointment.status !== 'pending' && appointment.status !== 'checkin'"><a class="text-success" @click="changeStatus('checkin')">{{this.$t('message.appointment.status_checkin')}}</a></li>
                  <li class="status-change status-change-btn"><a class="text-danger" @click="changeStatus('cancel ')">{{this.$t('message.appointment.status_cancel')}}</a></li>
                </bs-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-8 offset-md-2 step-body">
          <label for="fp">{{this.$t('message.appointment.label_date_time_appointment')}}</label>
          <flat-pickr v-model="appointment.appointment_time"
                      id="fp"
                      :config="fpConfig" required>
          </flat-pickr>

          <br/>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <label>{{this.$t('message.appointment.doctor')}}</label>
          <multiselect id="doctor" 
                    class="multi-select-form"
                    v-model="appointment.doctor" 
                    :placeholder="this.$t('message.appointment.doctor_placeholder')" 
                    :options="doctor_options"
                    :allow-empty="true" 
                    :disabled="isCancelAppointment"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
          <error-box :message="apmFrm.doctorIdError"/>
          <br/>
        </div>

        <div class="col-md-8 offset-md-2 step-body">
          <div class='row col-md-12'>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" ref="patient_type_a" v-model='patient_type' type="radio" name='patient_type' value="noexists" :disabled="isCancelAppointment"> {{$t('message.appointment.new_patient')}}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" ref="patient_type_b" v-model='patient_type' type="radio" name='patient_type' value="exists" :disabled="isCancelAppointment"> {{$t('message.appointment.old_patient')}}
              </label>
            </div>
          </div>
          <multiselect v-if="isExistingPatient" id="patient" 
                    class="multi-select-form"
                    v-model="selected_patient" 
                    :placeholder="this.$t('message.appointment.search_patient_placeholder')" 
                    :options="patient_list"
                    :allow-empty="true" 
                    :disabled="isCancelAppointment"
                    :loading="patientLoading"
                    @search-change="getPatients"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <label>{{this.$t('message.appointment.prefix')}}</label>
          <multiselect id="prefix" 
                    class="multi-select-form"
                    v-model="appointment.prefix" 
                    :placeholder="this.$t('message.appointment.prefix_placeholder')" 
                    :options="prefix_options" 
                    :allow-empty="true" 
                    :disabled="isCancelAppointment"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <bs-input class="remove-margin-bottom" :readonly="isExistingPatient" :label="this.$t('message.appointment.firstname')" v-model="appointment.firstname" :placeholder="this.$t('message.appointment.firstname_placeholder')" required :disabled="isCancelAppointment"></bs-input>
          <error-box :message="apmFrm.firstnameError"/>
          <br>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <bs-input class="remove-margin-bottom" :readonly="isExistingPatient" :label="this.$t('message.appointment.lastname')" v-model="appointment.lastname" :placeholder="this.$t('message.appointment.lastname_placeholder')" required :disabled="isCancelAppointment"></bs-input>
          <error-box :message="apmFrm.lastnameError"/>
          <br>
        </div>

        <div class="col-md-8 offset-md-2 step-body">
          <bs-input :readonly="isExistingPatient" :label="this.$t('message.appointment.hn')" v-model="appointment.hn" :placeholder="this.$t('message.appointment.hn')" :disabled="isCancelAppointment"></bs-input>
          <br>
        </div>
        <div class="col-md-8 offset-md-2 step-body phone-section">
          <div>
            <label>{{this.$t('message.appointment.phone')}}</label>
          </div>
          <input type='tel' id='phone' :readonly="isExistingPatient" v-model="appointment.phone" class='form-control' :disabled="isCancelAppointment">
          <error-box :message="apmFrm.phoneError"/>
          <br>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <bs-input class='remove-margin-bottom' :readonly="isExistingPatient" :label="this.$t('message.appointment.email')" type='email' v-model="appointment.email" :placeholder="this.$t('message.appointment.email_placeholder')" required :disabled="isCancelAppointment"></bs-input>
          <error-box :message="apmFrm.emailError"/>
          <br>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <label>{{this.$t('message.appointment.seen_doctor')}}</label>
          <div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" v-model='appointment.seen_doctor' type="radio" name='seen_doctor' value="1" :disabled="isCancelAppointment"> {{this.$t('message.appointment.have')}}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" v-model='appointment.seen_doctor' type="radio" name='seen_doctor' value="0" :disabled="isCancelAppointment"> {{this.$t('message.appointment.have_not')}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <label>{{this.$t('message.appointment.medical_record')}}</label>
          <div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" v-model='appointment.has_medical_record' type="radio" name='has_medical_record' value="1" :disabled="isCancelAppointment"> {{this.$t('message.appointment.have_yes')}}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" v-model='appointment.has_medical_record' type="radio" name='has_medical_record' value="0" :disabled="isCancelAppointment"> {{this.$t('message.appointment.have_no')}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <label>{{this.$t('message.appointment.booking_for')}}</label>
          <div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" v-model='appointment.for' type="radio" name='for' value="myself" :disabled="isCancelAppointment"> {{this.$t('message.appointment.myself')}}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <label class="form-check-label">
                <input class="form-check-input" v-model='appointment.for' type="radio" name='for' value="other" :disabled="isCancelAppointment"> {{this.$t('message.appointment.another')}}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <bs-input :label="this.$t('message.appointment.id_card')" :readonly="isExistingPatient" v-model="appointment.id_card" :placeholder="this.$t('message.appointment.id_card')" required :disabled="isCancelAppointment"></bs-input>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <label for="fp">{{this.$t('message.appointment.birthdate')}}</label>
          <flat-pickr v-model='appointment.birthday'
                      id="fp"
                      :config="fpConfigBirthday" required>
          </flat-pickr>
          <br/>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <div class="row">
            <div class="col-md-6">
              <label>{{this.$t('message.appointment.service')}}</label>
              <multiselect id="service" 
                    class="multi-select-form"
                    v-model="appointment.service" 
                    :placeholder="this.$t('message.appointment.service_placeholder')" 
                    :options="service_options" 
                    :allow-empty="true" 
                    :disabled="isCancelAppointment"
                    selected-label="" 
                    select-label="" 
                    deselect-label=""
                    label="label" 
                    track-by="label"></multiselect>
              <br/>
            </div>

            <div class="col-md-6">
              <label>{{this.$t('message.appointment.duration')}}</label>
              <bs-input type="Number" class="input-min" min=15 max=1440 :step="15" v-model.number="appointment.duration" :placeholder="this.$t('message.appointment.duration_placeholder')" :disabled="isCancelAppointment">
                  <span slot="after" class="input-group-addon">
                    <strong>{{this.$t('message.appointment.duration_unit')}}</strong>
                  </span>
              </bs-input>
            </div>
          </div>
        </div>
        <div v-if="appointment.comment" class="col-md-8 offset-md-2 step-body">
          <div class="row">
            <div class="col-md-12">
              <label>{{$t('message.appointment.addition')}}</label>
              <p>{{appointment.comment}}</p>
            </div>
          </div>
          <!-- <bs-input type="textarea" :label="this.$t('message.appointment.addition')" :value="appointment.comment" :placeholder="this.$t('message.appointment.addition_placeholder')" :disabled="true"></bs-input> -->
        </div>

        <div class="col-md-8 offset-md-2 step-body">
          <div class="row">
            <div class="col-md-12">
              <label>{{$t('message.appointment.locale')}}</label>
              <multiselect id="locale" 
                      class="multi-select-form"
                      v-model="appointment.locale" 
                      :placeholder="$t('message.appointment.locale_placeholder')" 
                      :options="locale_options" 
                      :allow-empty="false"
                      :disabled="isCancelAppointment"
                      selected-label="" 
                      select-label="" 
                      deselect-label=""
                      label="label" 
                      track-by="label"></multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <div>
              <button v-for="rt in templates.remark_templates" :key="rt.name" @click="appendRemark(rt.text)" type="button" class="btn btn-secondary btn-sm btn-remark-template" :disabled="isCancelAppointment">{{rt.name}}</button>
              <button @click.prevent="openRemarkEditor" type="button" class="btn btn-secondary btn-sm btn-success" style="padding-bottom: 0px;"><i class="fa fa-pencil-square-o"></i></button>
          </div>
          <bs-input ref="remark" type="textarea" :label="this.$t('message.appointment.remark')" v-model="appointment.remark" :placeholder="this.$t('message.appointment.remark_placeholder')" :disabled="isCancelAppointment"></bs-input>
        </div>
        <div class="col-md-8 offset-md-2 step-body">
          <bs-input type="textarea" :label="this.$t('message.appointment.admin_remark')" v-model="appointment.admin_note" :placeholder="this.$t('message.appointment.admin_remark_placeholder')" :disabled="isCancelAppointment"></bs-input>
        </div>
        <div class="col-md-8 offset-md-2 step-body form-group action-group">
          <button class="btn btn-cancel btn-lg" @click="back">{{this.$t('action_message.back')}}</button>
          <button v-if="!isCancelAppointment" class="btn btn-store btn-lg" @click="saveAppointment">{{this.$t('action_message.save')}}</button>
          <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
        </div>
      </div>
    </div>
    <div v-else class="animated fadeIn step-container">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="row">
            <div class="col-md-2 offset-md-5">
              <dot-loader :loading="true" size='60px'></dot-loader>
            </div>
          </div>
        </div>
      </div>
    </div>

    <sweet-modal ref='remarkModal' overlay-theme="dark">
      <remark-editor :remarks.sync="templates.remark_templates" @closeEditor="closeRemarkModal" @submitRemark="updateRemarks"></remark-editor>
    </sweet-modal>
  </div>
</template>

<script>
import 'intl-tel-input/build/css/intlTelInput.css'
import 'intl-tel-input'

import AppointmentMixin from './appointment_mixin'
import moment from 'moment'
import jq from 'jquery'
import flatPickr from 'vue-flatpickr-component'
import Multiselect from 'vue-multiselect'
import { input as BsInput, dropdown as BsDropdown } from 'vue-strap'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import DotLoader from 'vue-spinner/src/DotLoader'
import ErrorBox from '@/components/ErrorMessageBox'
import RemarkEditor from '@/components/RemarkEditor'
import { SweetModal } from 'sweet-modal-vue'

export default {
  mixins: [AppointmentMixin],
  components: {
    flatPickr,
    BsInput,
    BsDropdown,
    Multiselect,
    SyncLoader,
    DotLoader,
    ErrorBox,
    RemarkEditor,
    SweetModal
  },
  data () {
    let defaultFrmError = {
      firstnameError: null,
      lastnameError: null,
      phoneError: null,
      emailError: null,
      doctorIdError: null
    }

    let defaultMessageFrmError = {
      firstnameError: this.$t('message.appointment.firstname_require'),
      lastnameError: this.$t('message.appointment.lastname_require'),
      phoneError: this.$t('message.appointment.phone_require'),
      emailError: this.$t('message.appointment.email_require'),
      doctorIdError: this.$t('message.appointment.doctor_require')
    }
    return {
      defaultMessageFrmError: defaultMessageFrmError,
      loading: false,
      dataLoaded: false,
      appointment: {
        appointment_time: moment().format('YYYY-MM-DD HH:mm:ss'),
        duration: 15
      },
      fpConfig: {
        enableTime: true,
        altInput: true,
        wrap: true,
        time_24hr: true
      },
      fpConfigBirthday: {
        enableTime: false,
        altInput: true,
        wrap: true
      },
      doctor_options: [],
      service_options: [],
      prefix_options: [
        {value: 'mrs', label: this.$t('message.appointment.prefix_mrs')},
        {value: 'mr', label: this.$t('message.appointment.prefix_mr')},
        {value: 'ms', label: this.$t('message.appointment.prefix_ms')},
        {value: 'master', label: this.$t('message.appointment.prefix_master')},
        {value: 'miss', label: this.$t('message.appointment.prefix_miss')}
      ],
      apmFrm: Object.assign({}, defaultFrmError),
      selected_patient: null,
      patient_list: [],
      patientLoading: false,
      locale_options: [
        {value: 'en', label: 'English'},
        {value: 'th', label: 'ไทย'}
      ],
      patient_type: 'noexists',
      templates: {
        remark_templates: []
      }
    }
  },
  computed: {
    isExistingPatient () {
      return this.patient_type === 'exists'
    },
    isCancelAppointment () {
      return this.appointment.status === 'cancel'
    },
    dropdownStatus () {
      if (this.appointment.status === 'scheduled') {
        return 'success'
      } else if (this.appointment.status === 'checkin') {
        return 'success'
      } else if (this.appointment.status === 'pending') {
        return 'warning'
      } else if (this.appointment.status === 'cancel') {
        return ''
      }
      return ''
    }
  },
  watch: {
    selected_patient (v, old) {
      if (!v) return
      let p = this.patient_list.find(_p => _p.value === +v.value)
      if (p) {
        this.appointment = Object.assign(this.appointment,
          {
            firstname: p.data.firstname,
            lastname: p.data.lastname,
            email: p.data.email,
            ehr_patient_id: p.value,
            id_card: p.data.id_card,
            prefix: (p.data.prefix) ? ((p.data.prefix.value) ? p.data.prefix : this.prefix_options.find(d => d.value === p.data.prefix)) : null,
            hn: p.data.hn,
            birthday: p.data.birthday
          }
        )

        jq('#phone').intlTelInput('setNumber', p.data.phone)
      }
    },
    patient_type (v, old) {
      if (v === 'noexists') {
        // reset the patient option selected
        this.selected_patient = null
      }
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getPatients (search) {
      this.patientLoading = true
      this.$http.get(this.$APP_CONFIG.api.admin.patient(),
        { params: { clinic_id: this.$guser.user.clinic.id, search } }).then(res => {
          this.patientLoading = false
          this.patient_list = res.body.data.map(p => {
            return { label: this.patientDesc(p), value: p.id, data: p }
          })
        })
    },
    patientDesc (p) {
      return `${p.firstname} ${p.lastname} - ${p.phone} - ${p.email || ''}`
    },
    async cancelAppointment () {
      if (await this.$confirm(this.$t('message.appointment.are_you_wath_to_cancel'))) {
        this.$http.put(this.$APP_CONFIG.api.admin.appointment_action(this.appointment.id, 'cancel')).then(res => {
          if (res.body) {
            this.$toastr.success(this.$t('message.appointment.cancel_appointment_success'))
            this.back()
          }
        })
      }
    },
    saveAppointment () {
      if (this.appointment.status === 'cancel ') {
        this.cancelAppointment(this.appointment.id)
        return
      }

      let editedApm = this.extractAppointment()

      // Clear form
      this.apmFrm = Object.assign({}, this.defaultFrmError)
      // Validate form
      let defaultError = this.defaultMessageFrmError
      var invalid = false
      if (!editedApm.firstname) {
        this.apmFrm.firstnameError = defaultError.firstnameError
        invalid = true
      }

      if (!editedApm.lastname) {
        this.apmFrm.lastnameError = defaultError.lastnameError
        invalid = true
      }

      if (!editedApm.phone) {
        this.apmFrm.phoneError = defaultError.phoneError
        invalid = true
      }

      if (!editedApm.email) {
        this.apmFrm.emailError = defaultError.emailError
        invalid = true
      }

      if (!editedApm.doctor_id) {
        this.apmFrm.doctorIdError = defaultError.doctorIdError
        invalid = true
      }

      if (invalid) {
        return
      }

      // update
      this.loading = true
      this.$http.put(this.$APP_CONFIG.api.admin.appointment_id(editedApm.id), editedApm).then(res => {
        if (res.body.id) {
          this.loading = false
          this.$toastr.success(this.$t('action_message.save_success'))
          this.back()
        }
      },
      error => {
        this.loading = false
        this.showAppointmentFormFromError(error.body.error)
      })
    },
    changeStatus (status) {
      this.appointment.status = status
    },
    async loadData () {
      if (this.$route.params.id) {
        this.dataLoaded = false
        let doctors = await this.$http.get(this.$APP_CONFIG.api.admin.doctors(), { params: { clinic_id: this.$guser.user.clinic.id, disable_pagination: 1 } })
        if (doctors) {
          doctors.body.data.forEach(d => {
            this.doctor_options.push({
              label: (this.$i18n.locale === 'th') ? d.name_th : d.name_en,
              value: d.id
            })
          })
        }

        let srvOpt = await this.$http.get(this.$APP_CONFIG.api.admin.clinicme_services())
        if (srvOpt) {
          this.service_options = srvOpt.body.data.map(service => {
            return { label: service[this.$i18n.locale].name, value: service.id }
          })
        }

        let appointmentsRes = await this.$http.get(this.$APP_CONFIG.api.appointment_id(this.$route.params.id), { credentials: true })
        if (appointmentsRes.body) {
          this.appointment = Object.assign({}, appointmentsRes.body, {
            doctor: this.doctor_options.find(d => d.value === appointmentsRes.body.doctor_id),
            service: this.service_options.find(d => d.value === appointmentsRes.body.service_id),
            prefix: this.prefix_options.find(d => d.value === appointmentsRes.body.prefix),
            locale: this.locale_options.find(d => d.value === appointmentsRes.body.locale)
          })
        }

        this.dataLoaded = true
      }
    },
    extractAppointment () {
      let _a = Object.assign({
        clinic_id: this.$guser.user.clinic.id
      },
        this.appointment,
        {
          phone: jq('#phone').intlTelInput('getNumber'),
          sms_remark: this.appointment.remark
        }
      )

      // extract service id
      if (this.appointment.service) {
        _a.service_id = this.appointment.service.value
      }
      delete _a.service

      // extract doctor id
      if (this.appointment.doctor) {
        _a.doctor_id = this.appointment.doctor.value
      }
      delete _a.doctor
      delete _a.clinic

      // convert time
      if (this.appointment.appointment_time) {
        let mtime = moment(this.appointment.appointment_time).format('YYYYMMDDHHmm')
        _a.appointment_time = mtime
      }

      // extract prefix
      if (this.appointment.prefix) {
        _a.prefix = this.appointment.prefix.value
      }

      // extract locale
      if (this.appointment.locale) {
        _a.locale = this.appointment.locale.value
      }

      return _a
    },
    showAppointmentFormFromError (error) {
      if (error) {
        this.apmFrm.firstnameError = this.getMessageFromError(error.firstname)
        this.apmFrm.lastnameError = this.getMessageFromError(error.lastname)
        this.apmFrm.phoneError = this.getMessageFromError(error.phone)
        this.apmFrm.doctorIdError = this.getMessageFromError(error.doctor_id)
      }
    },
    getMessageFromError (errorObj) {
      var message = null
      if (errorObj && Array.isArray(errorObj)) {
        message = errorObj.join(' ')
      } else {
        message = errorObj
      }
      return message
    },
    appendRemark (content) {
      let newContent = ''
      if (this.appointment.remark) {
        newContent = this.appointment.remark + content
      } else {
        newContent = content
      }

      this.appointment = Object.assign(this.appointment, {
        remark: newContent
      })
    },
    openRemarkEditor () {
      this.$refs.remarkModal.open()
    },
    closeRemarkModal () {
      this.$refs.remarkModal.close()
    },
    updateRemarks () {
      let updatedClinic = {
        remark_templates: (this.templates.remark_templates) ? this.templates.remark_templates : []
      }

      this.$http.put(this.$APP_CONFIG.api.admin.clinicme(),
        updatedClinic,
        {headers: { 'content-type': 'application/json' }})
        .then(res => {
          if (res.body.status === 'success') {
            this.$guser.user.clinic.remark_templates = res.body.data.remark_templates
          }
        })
    }
  },
  created () {
    if (this.$guser.user.clinic.remark_templates === null) {
      this.$guser.user.clinic.remark_templates = this.remarkTemplates
    }
    this.templates.remark_templates = this.$guser.user.clinic.remark_templates

    this.loadData()
  },
  mounted () {
    var setupPhone = () => {
      if (this.dataLoaded) {
        jq('#phone').intlTelInput({ nationalMode: true, initialCountry: 'th', utilsScript: '/static/utils.js' })
        jq('#phone').intlTelInput('setNumber', this.appointment.phone)
      } else {
        setTimeout(setupPhone, 500)
      }
    }

    var setupPatient = () => {
      if (this.dataLoaded) {
        if (this.appointment.ehr_patient_id) {
          this.$refs.patient_type_b.click()
          this.selected_patient = { label: this.patientDesc(this.appointment), value: this.appointment.ehr_patient_id, data: this.appointment }
          this.patient_list = [
            this.selected_patient
          ]
        } else {
          this.$refs.patient_type_a.click()
        }
      } else {
        setTimeout(setupPatient, 500)
      }
    }

    setupPhone()
    setupPatient()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang='scss'>
@import "../../assets/base_container";

.phone-section {
  padding-bottom: 0.5rem;
}

.action-group {
  padding-bottom: 1.2rem;
}

.confirm-btn-lg .btn {
  padding: 0.7rem 3rem !important;
}

.status-change-btn {
  padding: 0.4rem 2.5rem !important;
}

.title-section {
    margin: auto !important;
  .title-text {
    margin-bottom: 0 !important;
  }
}

</style>



// WEBPACK FOOTER //
// AppointmentDetail.vue?039df84e